import { combineReducers } from 'redux';
// import all reducers
import alert from './alert';
import apply from './apply';
import auth from './auth';
import book from './book';
import calendar from './calendar';
import data from './data';
import dashboard from './dashboard';
import profile from './profile';
import parkingAuth from './parkingAuth';
import parkingData from './parkingData';

const rootReducer = combineReducers({
  alert,
  apply,
  auth,
  book,
  calendar,
  dashboard,
  data,
  parkingAuth,
  parkingData,
  profile,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/index.js